<template>
  <div class="offer-card">
    <div class="grid-x grid-margin-x">
      <div class="small-12 cell" v-if="card.image">
        <div class="offer-card__carousel" @click.stop.prevent>
          <div class="offer-card__aspect-ratio">
            <img
              :src="publicPath(card.image)"
              alt
              class="of-cover"
            />
          </div>
        </div>
      </div>
      <div
        class="offer-card__content small-12 cell flex-container flex-dir-column"
      >
        <h3 class="t-card mb-8 o-h" v-text="card.location"></h3>

        <!-- <p class="o-05 t-p-medium mb-16">
          <span v-for='line in card.address' :key='line' v-text='line'></span>
        </p>

        <div class="pt-16">
          <p class="t-p-medium fw-500 small-12 medium-auto cell mb-16">
          </p>
        </div> -->

        <div class='mb-16'>
          <p class='t-p-medium' v-for='line in addressLines' :key='line' v-html='line'></p>
        </div>

        <p class='t-p-medium' v-if='card.phone'><a :href='phoneUrl' v-text='card.phone'></a></p>
        <p class='t-p-medium' v-if='card.email'><a :href='emailUrl' class='c-dark-blue' v-text='card.email'></a></p>
      </div>
    </div>
  </div>
</template>

<script>
import publicPathMixin from './mixins/public-path-mixin'

export default {
  name: 'CardOffice',
  mixins: [
    publicPathMixin,
  ],
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  computed: {
    emailUrl() {
      return `mailto:${this.card.email}`
    },
    phoneUrl() {
      return `tel:${this.card.phone.replace(/\s/g, '')}`
    },
    addressLines() {
      if (Array.isArray(this.card.address)) {
        return this.card.address
      }
      return [this.card.address]
    }
  }
}
</script>
